import React, { memo, useCallback } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ButtonPrimary, Layout, LinkButton } from '../../../../../../../components';
import styles from './RegisterLimitFormActions.module.scss';

export const RegisterLimitFormActions = memo(
  ({
    history,
    match: {
      params: { id },
    },
    isDisabledSubmit = true,
  }: RouteComponentProps<{ id: string }> & { isDisabledSubmit?: boolean }) => {
    const handleNavBack = useCallback(() => {
      history.goBack();
    }, [history]);

    return (
      <Layout.Section className={styles['form-actions']} padded>
        <LinkButton className={styles['form-actions__back-button']} onClick={handleNavBack}>
          <MdArrowBack size={16} /> Voltar para limites
        </LinkButton>
        <ButtonPrimary type="submit" disabled={isDisabledSubmit}>
          {id ? 'Atualizar limite' : 'Criar limite'}
        </ButtonPrimary>
      </Layout.Section>
    );
  },
);

RegisterLimitFormActions.displayName = 'RegisterLimitFormActions';

export default withRouter(connect()(RegisterLimitFormActions));
